import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";
import { Logo } from "@/components/site/Logo";

function FullLoader() {
  return (
    <div className="min-h-screen bg-[#05050A] flex flex-col items-center justify-center gap-4">
      <Logo size="text-3xl" />
      <div className="w-8 h-8 border-2 border-cyan-500/30 border-t-cyan-400 rounded-full animate-spin" />
    </div>
  );
}

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  if (user === null) return <FullLoader />;
  if (user === false) return <Navigate to="/connexion" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}
